import { call, put, select, takeLatest } from 'redux-saga/effects'
import { ICmsInformationState } from '../store/cmsInformation.types'
import { CmsInformationConstants } from '../store/cmsInformation.constants'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getCmsInformationSelector } from '../selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { setSaveCmsInformationResponse } from '../store/cmsInformation.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setHasPatient } from '../../patientInformation/store/patientInformation.actions'

export function* saveCmsInformation() {
  const cmsInformation: ICmsInformationState = yield select(getCmsInformationSelector)
  const serviceId: string = yield select(getServiceIdSelector)

  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      billing: {
        ...pcrDoc.billing,
        cmsInformation: {
          ...cmsInformation,
        },
      },
    }
    try {
      yield put(setHasPatient(true))
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setSaveCmsInformationResponse(response))
    } catch (e) {
      yield put(throwPcrException(`saveCmsInformation() error: ${e}`))
    }
  }
}

export function* saveCmsInformationSaga() {
  yield takeLatest([CmsInformationConstants.CMSINFORMATION_ACTION_SAVE], performWithMutexHOG, saveCmsInformation)
}
